module.exports = __webpack_public_path__ + "img/05_Linear_Schieben-IFCG@2x.169c5cd7.jpg";